module.exports = __webpack_public_path__ + "img/f3.f3977c5f.png";